import { importMappingModel } from "../../../../businessLogic/models";

export const createImportMappingModel = (item) =>
  new importMappingModel(
    item.Id,
    item.TenantId,
    item.AziendaId,
    item.Type,
    item.MappedValue,
    item.Value,
    item.CreatedOn,
    item.ModifiedOn,
    item.CreatedBy,
    item.ModifiedBy
  );

export const upsertImportMapping = async ({
  mappedValuesList,
  type,
  mappedValue,
  value,
  tenantId,
  aziendaId,
  apiAddMapping,
  apiUpdateMapping,
}) => {
  let mappedValuesListArr = [...mappedValuesList];

  const hasCurrentItem =
    mappedValuesListArr.filter(
      (item) => item.type === type && item.mappedValue === mappedValue
    ).length > 0;

  if (!hasCurrentItem) {
    const result = await apiAddMapping.fetch({
      tenantId,
      aziendaId,
      type,
      mappedValue,
      value,
    });

    if (result?.data?.errors === undefined) {
      const item = result?.data?.data?.insert_import_mapping_one;
      if (item) {
        mappedValuesListArr.push(createImportMappingModel(item));
      }
    }

    return mappedValuesListArr;
  }

  const result = await apiUpdateMapping.fetch({
    tenantId,
    aziendaId,
    type,
    mappedValue,
    value,
  });

  if (result?.data?.errors === undefined) {
    const item = result?.data?.data?.update_import_mapping?.returning?.[0];
    if (item) {
      const currentItemIndex = mappedValuesListArr.findIndex((x) => x.id === item.Id);
      if (currentItemIndex >= 0) {
        mappedValuesListArr = [...mappedValuesListArr];
        mappedValuesListArr[currentItemIndex] = createImportMappingModel(item);
      }
    }
  }

  return mappedValuesListArr;
};

export const upsertProfPrestMapping = ({
  mappedProfPrestList,
  cf,
  prestId,
}) => {
  let mappedProfPrestListArr = [...mappedProfPrestList];
  const currentItemIndex = mappedProfPrestListArr.findIndex((x) => x.cf === cf);

  if (currentItemIndex < 0) {
    mappedProfPrestListArr.push({
      cf,
      prestId,
    });
    return mappedProfPrestListArr;
  }

  mappedProfPrestListArr = [...mappedProfPrestListArr];
  mappedProfPrestListArr[currentItemIndex] = {
    cf,
    prestId,
  };

  return mappedProfPrestListArr;
};
